// Widget Scripts
import themeBackground from './js/widgets/1-themeBackground.js';
import customTicketButton from './js/widgets/0-customTicketButton.js';

import videoWidget from './js/widgets/videoWidget.js';

import * as eventsWidget from './js/widgets/3-events-widget/index.js';

import customCards from './js/widgets/4-customCards.js';

import * as seoSignup from './js/widgets/5-seo-signup/index.js';

import scrollerSponsors from './js/widgets/7-scrollerSponsors.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
$(document).ready(function () {
  themeBackground();
  customTicketButton();

  if (globalThis.location.pathname === '/') {
    $(globalThis).on('load', function () {
      videoWidget();
    });
    eventsWidget.autoEventFeed();
    // eventsWidget.manualEventFeed();
    customCards();
    seoSignup.customSeoBlock();
    seoSignup.customSignup();

    scrollerSponsors();
  }
});
